import type { ComponentChildren, JSX } from "preact";
import { classNames } from "@gss/common/classNames";

type Fluid = boolean | "sm" | "md" | "lg" | "xl" | "xxl";

interface Props {
    fluid?: Fluid;
    className?: string;
    children?: ComponentChildren;
}

export function Container({
    fluid = false,
    className,
    children,
}: Props): JSX.Element {
    return (
        <div className={classNames(getContainerClass(fluid), className)}>
            {children}
        </div>
    );
}

function getContainerClass(
    fluid: Fluid,
):
    | "container"
    | "container-fluid"
    | "container-sm"
    | "container-md"
    | "container-lg"
    | "container-xl"
    | "container-xxl" {
    switch (fluid) {
        case false:
            return "container";
        case true:
            return "container-fluid";
        case "sm":
            return "container-sm";
        case "md":
            return "container-md";
        case "lg":
            return "container-lg";
        case "xl":
            return "container-xl";
        case "xxl":
            return "container-xxl";
        default: {
            const _ensureExhaustive: never = fluid;
            throw new Error("Unknown container fluid value");
        }
    }
}
